import React from 'react';

const DiscountTitle = ({ record }) => {
	return <span>Discount {record ? `"${record.name}"` : ''}</span>;
};
export default DiscountTitle;
